module.exports = __webpack_public_path__ + "static/media/circlePlusEvenOdd.f90e6af0.svg";